import { Component } from "react"
import { BuyInfoBlock } from "./BuyInfoBlock"
import { ExchangeContent } from "./ExchangeContent"
import { GetBtcBlock } from "./GetBtcBlock"
import { HowToBlock } from "./HowToBlock"
import { QuestionsBlock } from "./QuestionsBlock"
import { WhyUsBlock } from "./why-us"

export class IndexContent extends Component {
  render = () => (
    <>
      <BuyInfoBlock />

      <GetBtcBlock />

      <section className="map light">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-center map__title title">
                Buy Bitcoin around <br />
                the world with 7gates
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <img src="/img/map.png?1" alt="map" className="map__img img-fluid" />
            </div>
          </div>
        </div>
      </section>

      <WhyUsBlock />

      <HowToBlock />

      <QuestionsBlock />

      <section className="get-exchange">
        <ExchangeContent />
      </section>
    </>
  )
}
